import Header from './variants/Header';
import NoDistractionsHeader from './variants/NoDistractionsHeader';
import NoNavigationHeader from './variants/NoNavigationHeader';
import RFHeader from './variants/retrofit/Header';
import RFNoDistractionsHeader from './variants/retrofit/NoDistractionsHeader';
export * from './externals';
export * from './types'; // Exporting existing header variants

export { Header, NoDistractionsHeader, NoNavigationHeader }; // Exporting retro-fit header variants

export { RFHeader, RFNoDistractionsHeader };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/index.js
// module id = 1624
// module chunks = 11